export enum UsernameType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  EMAIL_PHONE = 'EMAIL_PHONE',
}

export enum CountryType {
  DEFAULT = 'DEFAULT',
  CUSTOM = 'CUSTOM',
}

export enum OperationType {
  CHECK = 'CHECK',
  UPSERT = 'UPSERT',
}

export interface Country {
  type: CountryType;
  allowedPk?: string[];
}

export interface Operation {
  username: {
    type: UsernameType;
  };
  country: Country;
}

export interface TenantOperations {
  [key: string]: Operation;
}

export interface TenantConfig {
  [OperationType.CHECK]: Operation;
  [OperationType.UPSERT]: Operation;
}

export interface Tenants {
  [key: string]: TenantConfig;
}

export interface IdentityUsernameConfig {
  operations: TenantOperations;
  tenants: Tenants;
}
